import {
  Stack,
  type StackProps
} from "@mui/material";
import { styled } from "@mui/material/styles";
import type { PropsWithChildren } from "react";
import background from "../../assets/access.png";

const BackgroundStack = styled(Stack)<
  StackProps & { src?: string }
>(({ src, theme }) => ({
  alignItems: "center",
  background: `${theme.linearGradients.gradientDAlternative06}, 
    ${theme.linearGradients.gradientDAlternative03}, url(${src})`,
  backgroundRepeat:"no-repeat",
  backgroundSize:"cover",
  flexGrow: 1,

  "> *": {
    marginTop: theme.spacing(10),

    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(3)
    }
  }
}));

export function Background({ children }: PropsWithChildren) {
  return (
    <BackgroundStack src={ background }>
      { children }     
    </BackgroundStack>
  );
}
